/*
 * @Author: Merlin
 * @Date: 2023-11-29 16:12:45
 * @LastEditors: Merlin
 * @LastEditTime: 2023-12-11 14:46:47
 * @Description:
 */
import {cn, en} from './locales/portal.js';

export default defineI18nConfig(() => ({
    legacy: false,
    locale: 'en',
    messages: {
        en,
        cn,
    },
}));
